import React from "react";
import "./AdminDashboardHome.css";

// Global dashboard filter bar (Admin Command Centre redesign). Drives only
// the /tasks-derived sections (Operational Performance, Task Health,
// Workload, Project Health, Task Breakdown, Recent Activity) -- the
// top-line summary-endpoint KPIs come from dedicated aggregate endpoints
// with no matching query support, so they intentionally stay on their own
// real, unfiltered totals (see AdminDashboard.js for the full reasoning).
const PERIOD_OPTIONS = [
  ["all", "All Time"],
  ["today", "Today"],
  ["7d", "Last 7 Days"],
  ["30d", "Last 30 Days"],
  ["month", "This Month"],
  ["custom", "Custom"],
];

function Select({ label, value, onChange, options, allLabel }) {
  return (
    <select className="adh-filter-select" aria-label={label} value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="ALL">{allLabel}</option>
      {options.map((opt) => (
        <option key={opt} value={opt}>{opt}</option>
      ))}
    </select>
  );
}

export default function AdminFilterBar({
  period, onPeriodChange, customFrom, customTo, onCustomFromChange, onCustomToChange,
  organisationOptions, organisation, onOrganisationChange,
  projectOptions, project, onProjectChange,
  unitOptions, unit, onUnitChange,
  statusOptions, status, onStatusChange,
  hasActiveFilters, onReset,
}) {
  return (
    <div className="adh-filterbar">
      <div className="adh-filterbar-row">
        <div className="adh-pill-group" role="group" aria-label="Date range">
          {PERIOD_OPTIONS.map(([key, label]) => (
            <button
              key={key}
              type="button"
              aria-pressed={period === key}
              className={`adh-pill-btn${period === key ? " adh-pill-btn--active" : ""}`}
              onClick={() => onPeriodChange(key)}
            >
              {label}
            </button>
          ))}
        </div>
        {period === "custom" && (
          <div className="adh-filter-daterow">
            <input type="date" className="adh-filter-date" aria-label="Custom range from" value={customFrom} onChange={(e) => onCustomFromChange(e.target.value)} />
            <span>to</span>
            <input type="date" className="adh-filter-date" aria-label="Custom range to" value={customTo} onChange={(e) => onCustomToChange(e.target.value)} />
          </div>
        )}
      </div>
      <div className="adh-filterbar-row">
        <Select label="Filter by organisation" value={organisation} onChange={onOrganisationChange} options={organisationOptions} allLabel="All Organisations" />
        <Select label="Filter by project" value={project} onChange={onProjectChange} options={projectOptions} allLabel="All Projects" />
        <Select label="Filter by department or unit" value={unit} onChange={onUnitChange} options={unitOptions} allLabel="All Departments/Units" />
        <Select label="Filter by task status" value={status} onChange={onStatusChange} options={statusOptions} allLabel="All Status" />
        {hasActiveFilters && (
          <button type="button" className="adh-filter-reset" onClick={onReset}>
            Reset Filters
          </button>
        )}
      </div>
    </div>
  );
}
